import React from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Table } from 'react-bootstrap';
import classNames from 'classnames';

const AdvanceTable = ({
 getTableProps,
 page,
 prepareRow,
 headerClassName,
 rowClassName,
 tableProps,
 getTableBodyProps,
 headerGroups,
 getRowProps
}) => {
 return (
  <SimpleBarReact>
   <Table {...getTableProps(tableProps)}>
    <thead className={headerClassName}>
     {headerGroups.map((headerGroup, i) => (
      <tr key={i} {...headerGroup.getHeaderGroupProps()}>
       {headerGroup.headers.map((column, index) => (
        <th key={index} {...column.getHeaderProps(column.getSortByToggleProps(column.headerProps))}>
         {/* {column.canGroupBy ? (
                    // Si la columna se puede agrupar, agreguemos un conmutador
                    <span {...column.getGroupByToggleProps()}>
                      {column.isGrouped ? '🛑 ' : '👊 '}
                    </span>
                  ) : null} */}
         {column.render('Header')}
         {column.canSort ? (
          column.isSorted ? (
           column.isSortedDesc ? (
            <span className="sort desc" />
           ) : (
            <span className="sort asc" />
           )
          ) : (
           <span className="sort" />
          )
         ) : (
          ''
         )}
        </th>
       ))}
      </tr>
     ))}
    </thead>
    <tbody {...getTableBodyProps()}>
     {page.map((row, i) => {
      prepareRow(row);
      //console.log({ row, i });
      return (
       <tr
        key={i}
        className={classNames(rowClassName, {
         'table-info': row.isSelected
        })}
        {...row.getRowProps(getRowProps(row))}
       >
        {row.cells.map((cell, index) => {
         return (
          <td
           className="p-1"
           // Con fines educativos, vamos a colorear el
           // celda dependiendo de qué tipo se le da
           // del enlace useGroupBy
           key={index}
           {...cell.getCellProps(cell.column.cellProps)}
           /* style={{
                        background: cell.isGrouped
                          ? '#0aff0082'
                          : cell.isAggregated
                          ? '#ffa50078'
                          : cell.isPlaceholder
                          ? '#ff000042'
                          : 'white'
                      }} */
          >
           {cell.isGrouped ? (
            // Si es una celda agrupada, agregue un expansor y un recuento de filas
            <>
             <span {...row.getToggleRowExpandedProps()}>{row.isExpanded ? '👇' : '👉'}</span> {cell.render('Cell')} (
             {row.subRows.length})
            </>
           ) : cell.isAggregated ? (
            // Si la celda es agregada, use Agregado
            // renderizador para celda
            cell.render('Aggregated')
           ) : cell.isPlaceholder ? null : ( // Para celdas con valores repetidos, renderizar nulo
            // De lo contrario, solo renderiza la celda regular
            cell.render('Cell')
           )}
          </td>
         );
        })}
       </tr>
      );
     })}
    </tbody>
    {/* <tbody>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} className={rowClassName} {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      {...cell.getCellProps(cell.column.cellProps)}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody> */}
   </Table>
  </SimpleBarReact>
 );
};

AdvanceTable.propTypes = {
 getTableProps: PropTypes.func,
 headers: PropTypes.array,
 page: PropTypes.array,
 prepareRow: PropTypes.func,
 headerClassName: PropTypes.string,
 rowClassName: PropTypes.string,
 tableProps: PropTypes.object,
 getTableBodyProps: PropTypes.func,
 headerGroups: PropTypes.array,
 getRowProps: PropTypes.func
};

export default AdvanceTable;
